export var TimeStretchEngine;
(function (TimeStretchEngine) {
    TimeStretchEngine[TimeStretchEngine["Transient"] = 0] = "Transient";
    TimeStretchEngine[TimeStretchEngine["SoundTouch"] = 1] = "SoundTouch"; /* , Signalsmith (Phase 2) */
})(TimeStretchEngine || (TimeStretchEngine = {}));
